/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import icClose from 'static/ic-close.png';
import icCoin from 'static/ic-coin-thumb.png'
import bgCoinThumbnail from 'static/bg-coin-thumbnail.png';
import bgCoin from 'static/bg-coin.png';
import btnViewWallet from 'static/btn-view-wallet.png';
import styled from 'styled-components';
import DropBanner from 'components/DropBanner';
import { DROP_TITLE, MODAL_TYPE } from 'helpers/constants';

const styleCenter = {
    position: "absolute",
    right: 0,
    left: 0,
    marginRight: "auto",
    marginLeft: "auto"
}
const styleCoinNum = {
    fontSize: "1.125rem",
    fontWeight: 700,
    lineHeight: "1.3125rem",
    letterSpacing: "0.46666669845581055px",
    top: '8.25rem',
    textAlign: "center",
    textShadow: "2px 2px rgba(109, 0, 0, 0.25)"
}
const Container = styled.div`
    height: 16rem`
const Content = styled.div`
  
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-align: left;
`

const Description = styled.div`
    font-size: .875rem;
    max-height: calc(100% - 20px);
    overflow-y: auto;
    padding-bottom: 10px;
    scroll-snap-align: start;

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 15px;
    }

    &::-webkit-scrollbar {
        visibility: hidden;
        width: 4px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 15px;
        background: linear-gradient(180deg, rgba(18, 30, 139, 0.55) 0%, rgba(187, 193, 255, 0.85) 100%);
        box-shadow: 0px 6.94px 5.34px 0px rgba(41, 0, 62, 0.4), 0px 2.33px 7.63px 0px rgb(118, 180, 225), -0.69px 1.39px 4.67px 0px rgba(185, 174, 255, 0.5) inset;
    }
`

function ModalBeeCoin({ isOpen, onCloseModal, totalCoin, gameCode }) {

    return (
        <>

            <Modal open={isOpen} onClose={onCloseModal} gameCode={gameCode}>

                <div className='h-100' style={{ padding: "1.25rem 0 0 1.25rem" }}>
                    <div className='flex justify-content-end'>
                        <img className='icon-header' src={icClose} onClick={() => onCloseModal()} style={{ marginRight: "1.625rem" }} />
                    </div>
                    <Container className='d-flex pl-3'>
                        <Container className='relative mt-[3rem]' style={{ minWidth: "14.5rem" }}>
                            <img src={bgCoinThumbnail} style={{ ...styleCenter, bottom: 0 }} />
                            <img src={icCoin} style={{ ...styleCenter, top: 0 }} />
                            <img src={bgCoin} style={{ ...styleCenter, top: "7.3rem", width: "11rem" }} />
                            <p style={{ ...styleCenter, ...styleCoinNum }}>{totalCoin}</p>
                            <a href={process.env.REACT_APP_DEEP_LINK_BEE_WALLET}><img src={btnViewWallet} style={{ ...styleCenter, top: "70%", width: "8.5rem" }} /></a>
                        </Container>

                        <Content className='pl-4 pr-3'>
                            <p className='mb-4 text-center uppercase' style={{ fontFamily: "Titillium Medium, sans-serif" }}>Cách sử dụng xu ong</p>
                            <Description>
                                <div className='wrap-text pr-3'>
                                    <p><strong>1. Làm thế nào để có xu ong</strong></p>
                                    <p>Bạn sẽ nhận được quà tặng xu ong khi tham gia chơi Game “Quay thật sung - trúng cực khủng”.</p>
                                    <br />
                                    <p><strong>2. Cách sử dụng xu ong</strong></p>
                                    <p>Bước 1: Bấm vào nút "Xem ví ong" ở bên cạnh để xem tổng số xu ong hiện có</p>
                                    <p>Bước 2: Chi tiêu thẻ MB Mastercard bất kỳ để rút tiền khỏi ví xu ong</p>
                                    <p>Số xu ong bạn được rút bằng tối đa 1% số tiền đã chi tiêu với thẻ MB Mastercard bất kỳ</p>
                                </div>
                            </Description>
                        </Content>
                    </Container>
                </div >

            </Modal >
            {isOpen && <DropBanner customClass="drop-top" title={DROP_TITLE[MODAL_TYPE.COIN]} />}
        </>
    );
}

export default ModalBeeCoin;